export default __webpack_public_path__ + "static/center-tr-d4478e7c46d1e38b7c491acd80b0dac5.webp";